export const path = {
  login: "/login",
  home: "/home",
  dashboard: "/dashboard",
  agents: "/agents",
  dealers: "/dealers",
  team: "/team",
  inventory: "/inventory",
  AdminInventory: "/admin-inventory",
  agentinventory: "/agent-inventory",
  profile: "/profile",
  dashboardadmin: "/dashboardadmin",
  fastagrequest: "/fastag-request",
  fastagactivation: "/fastag-activation",
  unauthorized: "/unauthorized",
  report: "/report",
  dashboardagent: "/dashboard/agent",
  distributoradmin: "/distributoradmin",
  ChangepasswordPage: "/change-password",
  masterFastag: "/master-fastag",
  masterFastagDistributor: "/distributor-master-fastag",
  transactions: "/transactions",
  transactionsN: "/transactions-n",
  support: "/support",
  MyAgentsRequest: "/Agents-Fastag-Request",
  MyFastagRequest: "/My-Fastag-Request",
  resetPassword: "/resetpassword",
};
